import { useEffect, useRef, RefObject } from "react"

export const useAdjustMinHeightForScroll = (
  ref: RefObject<HTMLElement>,
  hasScroll: boolean,
  additionalPixels: number = 8
) => {
  const originalMinHeightRef = useRef<string | null>(null)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    // Save original value only once (on first render)
    // strict "null" check to correctly handle the case when original minHeight is an empty string
    if (originalMinHeightRef.current === null) {
      const computedStyle = window.getComputedStyle(element)
      originalMinHeightRef.current = computedStyle.minHeight || ""
    }

    if (hasScroll) {
      const computedStyle = window.getComputedStyle(element)
      const currentMinHeight = parseFloat(computedStyle.minHeight) || 0
      element.style.minHeight = `${currentMinHeight + additionalPixels}px`
    } else {
      // Restore original value
      element.style.minHeight = originalMinHeightRef.current || ""
    }

    // Cleanup: restore original value on unmount
    return () => {
      if (element && originalMinHeightRef.current !== null) {
        element.style.minHeight = originalMinHeightRef.current || ""
      }
    }
  }, [ref, hasScroll, additionalPixels])
}
